export default "__VITE_ASSET__ARfDhE0Z__"